// Date helpers shared by the project forms: the native date input speaks
// yyyy-mm-dd while the API speaks ISO datetimes.

/** yyyy-mm-dd (native date input) → ISO datetime. */
export const toIso = (date: string) => new Date(date).toISOString();

/** yyyy-mm-dd `days` from today, in LOCAL time — the threshold a date rule
 *  compares against. Built from local parts on purpose: `toDateInput` goes
 *  through toISOString(), which is UTC and lands on the wrong day near midnight. */
export const todayPlus = (days: number) => {
  const d = new Date();
  d.setDate(d.getDate() + days);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

/** ISO datetime → yyyy-mm-dd for a native date input ('' when unset/invalid). */
export const toDateInput = (iso: string) => {
  if (!iso) return '';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '' : d.toISOString().slice(0, 10);
};
